import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Anything that matched no route at all.
 *
 * Without this the router rendered nothing: a mistyped path or a stale
 * bookmark under a real workspace produced an empty page with no message, no
 * way back and nothing in the console to explain it. A page that says what
 * happened and offers the way out is the minimum.
 */
export default function NotFoundPage() {
  const { pathname } = useLocation();
  // The first segment is the workspace when there is one, so a wrong path
  // inside a real workspace can offer that workspace rather than the login.
  const team = pathname.split('/').filter(Boolean)[0] || null;
  let signedIn = false;
  try { signedIn = Boolean(localStorage.getItem('accessToken')); } catch (_) { /* private mode */ }
  const home = team && signedIn ? `/${encodeURIComponent(team)}/overview` : '/login';
  return (
    <div style={{ fontFamily: 'Inter, sans-serif' }}
      className="flex min-h-screen flex-col items-center justify-center gap-3 bg-[color:var(--surface-base)] px-6 text-center">
      <div className="text-[15px] font-medium text-[color:var(--text-primary)]">This page does not exist</div>
      <div className="max-w-md text-[13px] leading-relaxed text-[color:var(--text-muted)]">
        Nothing is served at <span className="font-mono text-[color:var(--text-secondary)]">{pathname}</span>. The link may be out of date.
      </div>
      <Link to={home} replace
        className="mt-1 inline-flex h-8 items-center rounded-md bg-brand px-3 text-[12px] font-medium text-ink-onBrand hover:bg-brand-hover">
        {team && signedIn ? 'Go to the workspace' : 'Sign in'}
      </Link>
    </div>
  );
}
